module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921101149_T.c9281b79.jpg";